import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { UserState } from '../types/users';

const initialState: Array<UserState> = [
    {
        id: 0,
        name: '佐藤花子',
        division: '総務部',
        position: '主任',
        email: 'sato@example.com',
        role: 'admin'
    },
];

const usersSlice = createSlice({
    name: 'auth',
    initialState,
    reducers: {
        registerUser: (state: UserState[], action: PayloadAction<UserState>) => {
            state.push(action.payload);
        },
    },
});

export const { registerUser } = usersSlice.actions;

export default usersSlice.reducer;
